import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcReviewReviewProps,

    LoadCcReviewReviewItemById,
    LoadCcReviewReviewItemState,
    LoadCcReviewReviewHistory,
    LoadCcReviewReviewTempAnswers,

    setCcReviewReviewItemDetails,
    setCcReviewReviewItemState,
    setCcReviewReviewItemHistory,
    setCcReviewReviewTempAnswers,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"
import AnswerForm from "./form"


const ReviewReviewAnswer = ({
    reviewItemId,
    revisionId,
}: CcReviewReviewProps) => {
    const activeFile = useSelector((state: StoreType) => state.ccReviewDocument.activeFile)

    const item = useSelector((state: StoreType) => state.ccReviewReview.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadCcReviewReviewItemById(reviewItemId, activeFile.id).then((res) => {
                dispatch(setCcReviewReviewItemDetails(res))
            }),
            LoadCcReviewReviewItemState(reviewItemId, revisionId).then((res) => {
                dispatch(setCcReviewReviewItemState(res))
            }),
            LoadCcReviewReviewHistory(reviewItemId, revisionId).then((res) => {
                dispatch(setCcReviewReviewItemHistory(res))
            }),
            LoadCcReviewReviewTempAnswers(reviewItemId, revisionId).then((res) => {
                dispatch(setCcReviewReviewTempAnswers(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
                <AnswerForm />
            </PageContent>
        </Container>
    )
}
export default ReviewReviewAnswer
